export default __webpack_public_path__ + "static/media/historic-site.cdee7862.svg";